var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import moment from "moment";
var messages = defineMessages({
    check_date_of_issue: {
        id: "check.date_of_issue",
        defaultMessage: "«Opex» checks"
    },
    member_area_history_account_table_payment_amount: {
        id: "member-area.history_account_table_payment_amount",
        defaultMessage: "Amount"
    },
    check_status: {
        id: "check.status",
        defaultMessage: "Status"
    },
    check_check_number: {
        id: "check.check_number",
        defineMessages: "Check_number"
    },
    check_status_0: {
        id: "check.status_1",
        defineMessages: "Active"
    },
    check_status_1: {
        id: "check.status_2",
        defineMessages: "Paid off"
    },
    check_status_2: {
        id: "check.status_3",
        defineMessages: "Expired"
    }
});
var CheckItem = /** @class */ (function (_super) {
    __extends(CheckItem, _super);
    function CheckItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheckItem.prototype.render = function () {
        var _a = this.props, receipt = _a.receipt, curse = _a.curse;
        var usdtValue = curse ? (receipt.amount / curse.rate).toFixed(2) : '';
        return (_jsxs("div", __assign({ className: "opex-check" }, { children: [_jsxs("div", __assign({ className: "opex-check__item" }, { children: [_jsx("div", __assign({ className: "opex-check__item-title" }, { children: _jsx(FormattedMessage, __assign({}, messages.check_date_of_issue)) })), _jsx("div", __assign({ className: "opex-check__item-value" }, { children: moment(receipt.dateCreated).format("YYYY.MM.DD, HH:mm") }))] })), _jsxs("div", __assign({ className: "opex-check__item" }, { children: [_jsx("div", __assign({ className: "opex-check__item-title" }, { children: _jsx(FormattedMessage, __assign({}, messages.member_area_history_account_table_payment_amount)) })), _jsxs("div", __assign({ className: "opex-check__item-value" }, { children: [receipt.amount && receipt.amount, " ", usdtValue ? "(".concat(usdtValue, ")") : ""] }))] })), _jsxs("div", __assign({ className: "opex-check__item" }, { children: [_jsx("div", __assign({ className: "opex-check__item-title" }, { children: _jsx(FormattedMessage, __assign({}, messages.check_status)) })), _jsx("div", __assign({ className: "opex-check__item-value" }, { children: _jsx(FormattedMessage, __assign({}, messages["check_status_" + [receipt.state]])) }))] })), _jsxs("div", __assign({ className: "opex-check__item" }, { children: [_jsx("div", __assign({ className: "opex-check__item-title" }, { children: _jsx(FormattedMessage, __assign({}, messages.check_check_number)) })), _jsx("div", __assign({ className: "opex-check__item-value opex-check__item-value-bold" }, { children: receipt.pin }))] }))] })));
    };
    return CheckItem;
}(React.Component));
export default CheckItem;



// WEBPACK FOOTER //
// ./src/components/bironex-checks/CheckItem.jsx